import React from 'react'

function Alert({value}) {
  return (
    <div className='flex h-screen items-center justify-center'>
        <div className="max-w-md mx-auto p-6 bg-white border border-gray-300 rounded-lg shadow-sm">
            <div className="flex items-center">
                <div className="flex-shrink-0">
                    <svg className="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                </div>
                <div className="ml-3">
                    <p className="text-sm text-gray-700 font-medium">{value}</p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Alert